// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__gNOh1","light":"styles_light__yYPz1","dark":"styles_dark__2aKFw"};